module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Pride-And-Prejudice-landscape.bfd0127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Pride-And-Prejudice-landscape.jpg
// module id = S4V8
// module chunks = 0